import { GraphQlClient } from '@intelipost-js/secure-providers';

export default {
  saveEmailConfig({ commit }, payload) {
    const { preview_url } = payload; // eslint-disable-line
    commit('toggleLoading', true);

    return GraphQlClient.mutation(
      `mutation (
        $delivered: Boolean
        $cancelled: Boolean
        $in_transit: Boolean
        $intelipost_created: Boolean
        $shipped: Boolean
        $out_to_delivered: Boolean
        $sender_email: String
        $sender_name: String
        $logo_url: String
      ){
       email_tracking(
        delivered: $delivered
        cancelled: $cancelled
        in_transit: $in_transit
        intelipost_created: $intelipost_created
        shipped: $shipped
        out_to_delivered: $out_to_delivered
        sender_email: $sender_email
        sender_name: $sender_name
        logo_url: $logo_url
        ){
          logo_url
          sender_name
          sender_email
          in_transit
          intelipost_created
          shipped
          out_to_delivered
          delivered
          cancelled
          preview_url
        }
      }
      `, payload)
    .then((res) => {
      const { data = {} } = res || {};
      const { email_tracking = {} } = data;
      commit('toggleLoading', false);
      commit('setEmailConfig', email_tracking);

      return Promise.resolve(res || {});
    })
    .catch((err) => {
      commit('toggleLoading', false);

      return Promise.reject(err || {});
    });
  },
  saveSmsConfig({ commit }, payload) {
    commit('toggleLoading', true);

    return GraphQlClient.mutation(
      `mutation (
        $phone_number_sender: String
        $sender_name: String
        $intelipost_created: Boolean
        $shipped: Boolean
        $in_transit: Boolean
        $to_be_delivered: Boolean
        $delivered: Boolean
        $cancelled: Boolean
        $hour_to_end: String
        $hour_to_start: String
        $message_intelipost_created: String
        $message_shipped: String
        $message_in_transit: String
        $message_to_be_delivered: String
        $message_delivered: String
        $message_cancelled: String
      ){
        sms_tracking(
          phone_number_sender: $phone_number_sender
          sender_name: $sender_name
          intelipost_created: $intelipost_created
          shipped: $shipped
          in_transit: $in_transit
          to_be_delivered: $to_be_delivered
          delivered: $delivered
          cancelled: $cancelled
          hour_to_end: $hour_to_end
          hour_to_start: $hour_to_start
          message_intelipost_created: $message_intelipost_created
          message_shipped: $message_shipped
          message_in_transit: $message_in_transit
          message_to_be_delivered: $message_to_be_delivered
          message_delivered: $message_delivered
          message_cancelled: $message_cancelled

        ) {
           phone_number_sender
           sender_name
           intelipost_created
           shipped
           in_transit
           to_be_delivered
           delivered
           cancelled
           hour_to_end
           hour_to_start
           message_intelipost_created
           message_shipped
           message_in_transit
           message_to_be_delivered
           message_delivered
           message_cancelled
        }
      }`, payload)
      .then((res) => {
        const { data = {} } = res || {};
        const { sms_tracking = {} } = data;
        commit('toggleLoading', false);
        commit('setSMSConfig', sms_tracking);
        return Promise.resolve(res || {});
      })
      .catch((err) => {
        commit('toggleLoading', false);
        return Promise.reject(err || {});
      });
  },
  saveWebHookConfig({ commit }, payload) {
    commit('toggleLoading', true);

    return GraphQlClient.mutation(
      `mutation(
        $enabled: Boolean
        $protocol: String
        $host: String
        $path: String
        $port: String
        $auth_type: String
        $user: String
        $passwd: String
      ){
        webhook_tracking(
          enabled: $enabled
          protocol: $protocol
          host: $host
          path: $path
          port: $port
          auth_type: $auth_type
          user: $user
          passwd: $passwd

        ) {
          enabled
          protocol
          host
          path
          port
          auth_type
          user
          passwd
        }
      }
      `, payload).then((res) => {
        const { data = {} } = res || {};
        const { webhook_tracking = {} } = data;

        commit('toggleLoading', false);
        commit('setWebhookConfig', webhook_tracking);
        return Promise.resolve(res || {});
      })
      .catch((err) => {
        commit('toggleLoading', false);
        return Promise.reject(err || {});
      });
  },

  getEmailConfig({ commit }) {
    commit('toggleLoading', true);

    return GraphQlClient.query(
      `query {
          email_tracking {
            logo_url
            sender_name
            sender_email
            intelipost_created
            shipped
            in_transit
            out_to_delivered
            delivered
            cancelled
            preview_url
          }
        }`,
    )
    .then((res) => {
      const { data = {} } = res || {};
      const { email_tracking = {} } = data;

      commit('toggleLoading', false);
      commit('setEmailConfig', email_tracking);
      return Promise.resolve(res || {});
    })
    .catch((err) => {
      commit('toggleLoading', false);
      return Promise.reject(err || {});
    });
  },

  getSmsConfig({ commit }) {
    commit('toggleLoading', true);

    return GraphQlClient.query(`
    query {
      sms_tracking {
        phone_number_sender
        sender_name
        intelipost_created
        shipped
        in_transit
        to_be_delivered
        delivered
        cancelled
        hour_to_end
        hour_to_start
        message_intelipost_created
        message_shipped
        message_in_transit
        message_to_be_delivered
        message_delivered
        message_cancelled
      }
    }
    `)
    .then((res) => {
      const { data = {} } = res || {};
      const { sms_tracking = {} } = data;
      commit('toggleLoading', false);
      commit('setSMSConfig', sms_tracking);
      return Promise.resolve(res || {});
    })
    .catch((err) => {
      commit('toggleLoading', false);

      return Promise.reject(err || {});
    });
  },
  getWebHookConfig({ commit }) {
    commit('toggleLoading', true);

    return GraphQlClient.query(`
    query {
      webhook_tracking {
        enabled
        protocol
        host
        path
        port
        auth_type
        user
        passwd
      }
    }
    `)
    .then((res) => {
      const { data = {} } = res || {};
      const { webhook_tracking = {} } = data;
      commit('toggleLoading', false);
      commit('setWebhookConfig', webhook_tracking);
      return Promise.resolve(res || {});
    })
    .catch((err) => {
      commit('toggleLoading', false);
      return Promise.reject(err || {});
    });
  },

};



// WEBPACK FOOTER //
// ./src/features/private/settings/pages/tracking-config/store/actions.js